import 'core-js/stable'

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import 'ant-design-vue/dist/antd.css';
import VueAnalytics from 'vue-analytics';

Vue.config.productionTip = false;

Vue.use(Antd);

Vue.use(VueAnalytics, {
  id: 'UA-166749335-1',
  router
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");